import { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Lock, User as UserIcon, Loader2 } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../hooks/use-toast';

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      const from = location.state?.from?.pathname || '/admin';
      navigate(from, { replace: true });
    }
  }, [user, navigate, location]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.username, form.password);
      toast({ title: 'Welcome back!', description: 'Redirecting to admin dashboard...' });
      navigate('/admin');
    } catch (err) {
      toast({ title: 'Login failed', description: 'Invalid username or password.', variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-900 via-neutral-800 to-neutral-900 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-8">
          <img src="/assets/logo.png" alt="Terra Homes Realty" className="h-20 w-auto bg-white rounded p-2" />
        </Link>
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h1 className="text-2xl font-bold text-neutral-900 text-center">Admin Sign In</h1>
          <p className="text-center text-neutral-500 text-sm mt-1">Terra Homes Realty CMS</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-sm font-medium text-neutral-700 mb-1 block">Username</label>
              <div className="relative">
                <UserIcon className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
                <Input required autoFocus value={form.username} onChange={(e) => setForm({...form, username: e.target.value})} className="pl-9 h-11" placeholder="admin" />
              </div>
            </div>
            <div>
              <label className="text-sm font-medium text-neutral-700 mb-1 block">Password</label>
              <div className="relative">
                <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
                <Input required type="password" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} className="pl-9 h-11" />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="btn-primary w-full h-11">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Sign In'}
            </Button>
          </form>
          <p className="text-xs text-center text-neutral-400 mt-6">Authorized personnel only.</p>
        </div>
      </div>
    </div>
  );
}
